import { createContext, ReactNode, useState, useEffect } from 'react';
import { User } from '../types/user';
import { getUser } from '../api/user/getUser';
import Cookies from 'react-cookies';

type AuthContextType = {
  isAuthenticated: boolean;
  userData: any;
  setAuth: (auth: boolean) => void;
  setUserData: (user: User | null) => void;
};

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  userData: null,
  setAuth: () => {},
  setUserData: () => {},
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setAuth] = useState<boolean>(false);
  const [userData, setUserData] = useState<User | null>(null);

  useEffect(() => {
    if (Cookies.load('isUser')) setAuth(true);
    getUser(Cookies.load('payload-token') || null)
      .then((res) => {
        if (res.user && res.user.roleGroup === 'user') {
          setAuth(true);
          setUserData(res.user);
        } else {
          setAuth(false);
          Cookies.remove('payload-token');
          Cookies.remove('isUser');
        }
      })
      .catch(() => {
        setAuth(false);
        Cookies.remove('isUser');
      });
  }, []);

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setAuth, userData, setUserData }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
